import React, { PureComponent } from 'react'
import Icon from '@mdi/react'
import IconButton from '@material-ui/core/IconButton'
import Slider from '@material-ui/core/Slider'
import Tooltip from '@material-ui/core/Tooltip'

import {
  mdiPlay,
  mdiPause,
  mdiSkipBackward,
  mdiSkipForward,
  mdiSkipNext,
  mdiSkipPrevious,
  mdiRepeat,
} from '@mdi/js'

const iconColor = '#FFFFFF'
const iconColorMuted = 'rgba(255,255,255,0.35)'

class CinePlayer extends PureComponent {
  firstframe = () => {
    this.props.runCinePlayer('firstframe')
  }

  previousframe = () => {
    this.props.runCinePlayer('previousframe')
  }

  play = () => {
    this.props.runCinePlayer('play')
  }

  pause = () => {
    this.props.runCinePlayer('pause')
  }

  nextframe = () => {
    this.props.runCinePlayer('nextframe')
  }

  lastframe = () => {
    this.props.runCinePlayer('lastframe')
  }

  toggleLoop = () => {
    if (this.props.onLoopChange) {
      this.props.onLoopChange(!this.props.loop)
    }
  }

  handleFpsChange = (event, value) => {
    if (this.props.onFpsChange) {
      this.props.onFpsChange(value)
    }
  }

  render() {
    const fps = this.props.fps != null ? this.props.fps : 30
    const loop = this.props.loop !== false
    const inPlay = !!this.props.inPlay
    const minFps = this.props.minFps || 1
    const maxFps = this.props.maxFps || 60

    return (
      <div
        data-cine-controls="true"
        onPointerDown={(e) => e.stopPropagation()}
        onPointerUp={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        onTouchEnd={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 300,
          margin: '0 auto',
          padding: '4px 8px 8px',
          boxSizing: 'border-box',
          touchAction: 'manipulation',
          WebkitUserSelect: 'none',
          userSelect: 'none',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton onClick={this.firstframe} size="small" aria-label="Primera">
            <Icon path={mdiSkipBackward} size={'1.35rem'} color={iconColor} />
          </IconButton>
          <IconButton onClick={this.previousframe} size="small" aria-label="Anterior">
            <Icon path={mdiSkipPrevious} size={'1.35rem'} color={iconColor} />
          </IconButton>
          {inPlay ? (
            <IconButton onClick={this.pause} size="small" aria-label="Pausa">
              <Icon path={mdiPause} size={'1.5rem'} color={iconColor} />
            </IconButton>
          ) : (
            <IconButton onClick={this.play} size="small" aria-label="Play">
              <Icon path={mdiPlay} size={'1.5rem'} color={iconColor} />
            </IconButton>
          )}
          <IconButton onClick={this.nextframe} size="small" aria-label="Siguiente">
            <Icon path={mdiSkipNext} size={'1.35rem'} color={iconColor} />
          </IconButton>
          <IconButton onClick={this.lastframe} size="small" aria-label="Última">
            <Icon path={mdiSkipForward} size={'1.35rem'} color={iconColor} />
          </IconButton>
          <Tooltip title={loop ? 'Loop: on' : 'Loop: off'}>
            <IconButton onClick={this.toggleLoop} size="small" aria-label="Loop" aria-pressed={loop}>
              <Icon path={mdiRepeat} size={'1.2rem'} color={loop ? iconColor : iconColorMuted} />
            </IconButton>
          </Tooltip>
        </div>

        <div style={{ padding: '0 10px 2px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: 10,
              color: 'rgba(255,255,255,0.75)',
              marginBottom: -2,
              userSelect: 'none',
            }}
          >
            <span>Velocidad</span>
            <span>{fps} fps</span>
          </div>
          <Slider
            value={fps}
            min={minFps}
            max={maxFps}
            step={1}
            onChange={this.handleFpsChange}
            aria-label="FPS"
            style={{ color: '#81C784', padding: '6px 0' }}
          />
        </div>
      </div>
    )
  }
}

export default CinePlayer
